export { default } from "./TagPremium"
